export default __webpack_public_path__ + "8afa3cdbd84a1713de18bedb9d3f89ef.mp3";